module.exports = __webpack_public_path__ + "img/baidu-yiyan-icon.53547ed0.png";